// src/styles/commonStyles.js

export const getCommonContainerStyles = (themeVars, isMobile) => ({
  outer: {
    position: "relative",
    zIndex: 2,
    minHeight: "100vh",
    color: themeVars.fg,
    fontFamily: "Inter, Arial, sans-serif",
    display: "flex",
    flexDirection: "column",
    alignItems: "stretch",
  },
  inner: {
    width: "100%",
    maxWidth: "100%",
    background: themeVars.subtleBg,
    backdropFilter: "blur(12px)",
    WebkitBackdropFilter: "blur(12px)",
    padding: isMobile ? "32px 16px 60px" : "48px clamp(16px, 3vw, 48px) 80px",
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
});

export const getCommonH1Styles = (themeVars, isMobile) => ({
  textAlign: "center",
  fontSize: isMobile ? "2.6rem" : "3.4rem",
  fontWeight: "800",
  background: themeVars.btnBg,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  marginBottom: isMobile ? "32px" : "48px",
  lineHeight: "1.1",
});

// Единый хелпер для h1 с учётом Samsung-браузера.
// Samsung не поддерживает gradient text clip — используем solid color.
export const getH1Style = (themeVars, isMobile, isSamsungBrowser) =>
  isSamsungBrowser
    ? {
        ...getCommonH1Styles(themeVars, isMobile),
        background: 'none',
        WebkitTextFillColor: 'unset',
        color: '#3730a3',
      }
    : getCommonH1Styles(themeVars, isMobile);

export const getCommonTextStyles = (isMobile) => ({
  lineHeight: "1.65",
  fontSize: isMobile ? "1.12rem" : "1.28rem",
});